<template>
	<div class="d-flex flex-row justify-space-between align-content-center px-0">
		<botao-tooltip
			v-if="documento.idDocumentoAta"
			data-testid="action-baixar"
			icone="mdi-download"
			cor="grey"
			texto="Baixar Documento"
			@click="baixarAta(documento)"
		></botao-tooltip>
	</div>
</template>

<script>
import { actionTypes } from '@/core/constants'
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'

export default {
	name: 'listagem-modal-documentos-botoes-acoes',
	components: { BotaoTooltip },
	props: {
		documento: {
			type: Object,
			required: true,
		},
	},
	methods: {
		async baixarAta(documento) {
			await this.$store.dispatch(actionTypes.DOCUMENTOS.BAIXAR_DOCUMENTO, documento.idDocumentoAta)
		},
	},
}
</script>

<style scoped></style>
